import { History } from 'history';

export type ErrorMsgFormat = {
    count: number;
    singular: string;
    text: string;
} & {
    plural?: string;
    path?: string;
    targetColumn?: string; // Filter on which column
    targetValue?: string[]; // Filter based on which values
    targetTab?: string; // Optional tab id property
    tailingComponent?: JSX.Element;
}

export const routeChange = (history: History, path: string, targetColumn?: string, targetValue?: string[], targetTab?: string) => {
    history.push({
        pathname: path,
        state: {
            targetTab,
            targetColumn,
            targetValue,
        },
    });
};
